import { z } from 'zod';

/**
 * AI Activity Log DTO — feeds the drawer in the app shell (last 7 days
 * of AI actions for the current user) and the dedicated `/ai-activity`
 * page in Phase 1.5+.
 */

export const AiActionStatus = z.enum(['success', 'partial', 'fallback', 'error']);
export type AiActionStatusValue = z.infer<typeof AiActionStatus>;

export const AiActionLogSchema = z.object({
  id: z.string().uuid(),
  teamId: z.string().uuid(),
  userId: z.string().uuid(),
  feature: z.string(),
  action: z.string(),
  targetKind: z.string().nullable(),
  targetId: z.string().uuid().nullable(),
  status: AiActionStatus,
  summary: z.string().nullable(),
  modelId: z.string().nullable(),
  provider: z.string().nullable(),
  promptVersion: z.string().nullable(),
  costUsd: z.number(),
  latencyMs: z.number().int().nonnegative(),
  correlationId: z.string().nullable(),
  createdAt: z.string(),
});
export type AiActionLogProjection = z.infer<typeof AiActionLogSchema>;

export const AiActivityListResponseSchema = z.object({
  items: z.array(AiActionLogSchema),
});
export type AiActivityListResponse = z.infer<typeof AiActivityListResponseSchema>;
